import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Round } from '../../shared/model/poll.model';

@Component({
  selector: 'app-list-election-choices',
  templateUrl: 'list-election-choices.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./list-election-choices.component.less', '../../shared/common.less'],
})

export class ListElectionChoicesComponent implements OnInit {
  @Input() isMobile: boolean;
  @Input() votingProof: string = '';
  @Input() rounds: Array<Round>;
  @Input() votedStatuses: boolean[] = [];
  @Output() electionSelected: EventEmitter<number> = new EventEmitter<number>();
  
  ngOnInit() {
    console.log(this.votedStatuses);
    
  }

  setActiveElection(event: number) {
    this.electionSelected.emit(event);
  }
}
